import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, StyleType } from '../utils/transformProps/types'

export type DisplayKeys = 'display'

type DisplayValues = 'none' | 'flex' | 'inline'

export type DisplayProp = {
    [key in DisplayKeys]?: DisplayValues | DisplayValues[]
}

export const displayConfig: ConfigType<DisplayKeys> = {
    display: {
        property: ['display'],
        scale: '',
    },
}

export const display = css<DisplayProp>`
    ${(props): StyleType => transformProps(displayConfig, props)}
`
